import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

/**
 * Wrapper that fades + blurs in the route content on each navigation.
 * Keyed on pathname (without hash) so anchor-scroll inside the same page
 * does NOT retrigger the transition.
 */
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 12, filter: "blur(6px)" }}
      animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
